import { TYPE_ROUND } from "@/preferences";
import Decimal from "decimal.js";

export function roundPrice(
  numberRound: number,
  typeRound: string,
  input: Decimal
): number {
  const factor = Math.pow(10, numberRound);
  const valueDecimal = new Decimal(input).div(factor).toNumber();

  let valueRounded: number;
  switch (typeRound) {
    case TYPE_ROUND[0]:
      valueRounded = Math.ceil(valueDecimal);
      break;
    case TYPE_ROUND[1]:
      valueRounded = Math.floor(valueDecimal);
      break;
    case TYPE_ROUND[2]:
      valueRounded = Math.round(valueDecimal);
      break;
    default:
      throw new Error("Invalid rounding type");
  }

  return new Decimal(valueRounded).mul(factor).toNumber();
}
